import { gql } from "@apollo/client";

export const AddDeviceToken = gql`
mutation AddSupplierDeviceToken($input: SupplierAddDeviceTokenInput) {
    addSupplierDeviceToken(input: $input)
  }
`;